module.exports = __webpack_public_path__ + "img/img_middle.3db1a4da.png";